<template>
  <!--  <div class="container mx-auto mb-5">-->
  <!--    <SharedSearchForm />-->
  <!--  </div>-->
  <div class="contents lg:block lg:sticky lg:top-0 z-40 bg-neutral-50" data-behaviour="SearchResultStickyStack">
    <div class="relative z-40 bg-neutral-50 lg:flex lg:items-stretch w-full lg:container lg:max-w-full pt-4 pb-4 md:pb-1">
      <div class="lg:flex-none container mx-auto w-auto lg:min-w-full xl:min-w-[850px] 2xl:min-w-[1140px] 1xl:min-w-[1060px] px-8 pb-2 lg:pb-0">
        <div class="bg-white rounded-xl border border-neutral-200 drop-shadow-md lg:drop-shadow-none lg:shadow-md lg:py-1.5 lg:px-1.5">
          <div class="text-left grid grid-cols-1 lg:grid-cols-5 gap-y-0">
            <div class="col-span-1 lg:col-span-2 lg:border-r border-neutral-200 border-b lg:border-b-0 pr-0 lg:pr-2">
              <SearchFilterLocation :params="searchParamsStore" design="searchresultSearchbar" :update-on-input="false" @update="update($event)" />
            </div>
            <div class="col-span-1 lg:col-span-2 custom-dropdown-trigger-block border-neutral-200 border-b lg:border-b-0 px-0 lg:px-2 relative">
              <SearchFilterTravelDates
                :params="searchParamsLocal"
                :flex-search="props.flexSearch"
                :highlight-when-empty="true"
                design="searchresultSearchbar"
                @shown="modalOrDropdownShown()"
                @update="updateLocal($event)"
                @hidden="modalOrDropdownHidden()"
              />
            </div>
            <div class="col-span-1 pt-0.5 lg:pt-0 custom-dropdown-trigger-block lg:border-l border-neutral-200 pl-0 lg:pl-2">
              <SearchFilterGuestsBedroomsPets
                :params="searchParamsLocal"
                design="searchresultSearchbar"
                @shown="onGuestsModalOrDropdownShown"
                @update="updateLocal($event)"
                @hidden="onGuestsModalOrDropdownHidden"
              />
            </div>
          </div>
        </div>
        <div
          :class="[
            'grid transition-[grid-template-rows,opacity,margin] duration-300 ease-in-out text-left -mt-1.5 lg:mt-0 lg:px-1.5',
            searchParamsLocal.von
              ? 'grid-rows-[0fr] opacity-0 mb-0 [transition-delay:0ms,300ms,0ms]'
              : 'grid-rows-[1fr] opacity-100 -mb-3 [transition-delay:300ms,0ms,0ms]',
          ]"
        >
          <div class="overflow-hidden min-h-0">
            <div class="grid lg:grid-cols-5 gap-y-0">
              <div
                class="lg:col-start-3 lg:col-span-2 rounded-t-none rounded-b-lg bg-cta-50 lg:pb-1.5 pb-2 pt-4 lg:pt-1 lg:mt-0 text-xs font-medium text-center text-cta-700"
              >
                {{ t('hint_select_date') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lg:flex-1 hidden lg:block">
        <div class="h-full" />
      </div>
    </div>
    <div class="sticky top-0 z-30 lg:static bg-neutral-50 border-b border-neutral-200 py-4">
      <div class="lg:flex lg:items-stretch w-full container lg:max-w-full mx-auto px-8 min-w-0">
        <div class="flex gap-1.5 md:gap-3 min-w-0 w-full overflow-hidden">
          <UiSearchFilter
            aria-haspopup="true"
            :active="filter.showModal"
            :filter-set="searchParamsStore.activeFiltersCountForAllFieldsExceptOrtVonBisPersonen > 0"
            @click="filter.showModal = true"
          >
            <span class="flex flex-row min-w-0">
              <span class="hidden lg:inline truncate">{{ t('all_filters') }}</span>
              <span class="inline lg:hidden truncate">{{ t('filter') }}</span>
              <span
                v-if="searchParamsStore.activeFiltersCountForAllFieldsExceptOrtVonBisPersonen > 0"
                class="inline-flex items-center justify-center bg-petrol-500 text-white rounded-full min-h-[24px] min-w-[24px] px-0.5 font-normal leading-none text-center -my-0.5 ml-2 -mr-1.5 shrink-0"
              >
                {{ searchParamsStore.activeFiltersCountForAllFieldsExceptOrtVonBisPersonen }}
              </span>
            </span>
          </UiSearchFilter>
          <UiButton
            aria-haspopup="true"
            color="white-no-active-change"
            buttonpadding="px-3 py-2"
            buttonstyle="rounded-full border border-neutral-200 block lg:hidden text-sm"
            @click="mapButtonClick"
          >
            <template #icon>
              <UiIcon src="/svg/icons/map.svg" width="16" height="16" alt="Map" class="fill-black inline-block" />
            </template>
            <template #default>
              {{ t('map') }}
            </template>
          </UiButton>
          <div class="block lg:hidden min-w-0 overflow-hidden">
            <SearchFilterSorting :params="searchParamsStore" design="pill" width="w-full" @update="update($event)" />
          </div>
          <div class="hidden lg:block min-w-0 overflow-hidden">
            <SearchFilterDropdown
              :results-count="resultsCount"
              :active="searchParamsStore.activeFiltersCountForMultipleFields(['haustyp'], []) > 0"
              :label-dropdown="t('type_of_accommodation')"
              @reset="searchParamsStore.$patch({haustyp: []}); resetSearchParamsLocal()"
              @shown="modalOrDropdownShown()"
              @hidden="modalOrDropdownHidden()"
            >
              <template #trigger>
                {{ t('type_of_accommodation') }}
              </template>
              <template #default>
                <fieldset class="grid grid-cols-2 gap-4 py-3 px-5 text-left mb-4 min-w-[340px] w-max max-w-[min(90vw,28rem)] border-0">
                  <legend class="col-span-2 font-semibold float-left w-full">
                    {{ t('accommodation_type') }}
                  </legend>
                  <div class="min-w-0">
                    <UiCheckbox
                      id="ferienhaus"
                      v-model="searchParamsLocal.haustyp"
                      :value="'Ferienhaus'"
                      label-position="top"
                      design-label="pl-2 break-words"
                      :accessibility-label="t('accommodation_type_house')"
                      class="text-base"
                    >
                      <template #label>
                        {{ t('accommodation_type_house') }}
                      </template>
                    </UiCheckbox>
                  </div>
                  <div class="min-w-0">
                    <UiCheckbox
                      id="ferienwohnung"
                      v-model="searchParamsLocal.haustyp"
                      :value="'Ferienwohnung'"
                      label-position="top"
                      design-label="pl-2 break-words"
                      :accessibility-label="t('accommodation_type_apartment')"
                      class="text-base"
                    >
                      <template #label>
                        {{ t('accommodation_type_apartment') }}
                      </template>
                    </UiCheckbox>
                  </div>
                </fieldset>
              </template>
            </SearchFilterDropdown>
          </div>
          <div class="hidden lg:block min-w-0 overflow-hidden">
            <SearchFilterDropdown
              :results-count="resultsCount"
              :label-dropdown="t('price_night')"
              :active="searchParamsStore.activeFiltersCountForMultipleFields(['preis', 'preis_min'], []) > 0"
              @reset="searchParamsStore.$patch({preis: 0, preis_min: 0}); resetSearchParamsLocal()"
              @shown="modalOrDropdownShown()"
              @hidden="modalOrDropdownHidden()"
            >
              <template #trigger>
                {{ t('price_night') }}
              </template>
              <template #default>
                <div class="grid grid-cols-1 gap-4 py-3 px-4 text-left w-[400px]">
                  <div class="font-semibold">
                    {{ t('per_night') }}:
                  </div>
                  <div class="grid grid-cols-2 gap-x-4 gap-y-2">
                    <div>
                      <UiInputPrice v-model="searchParamsLocal.preis_min" type="number" placeholder="€">
                        <template #label>
                          {{ t('minimum_price') }}
                        </template>
                        <template v-if="searchParamsLocal.preis_min" #value>
                          <span class="invisible">{{ searchParamsLocal.preis_min }}</span> &euro;
                        </template>
                      </UiInputPrice>
                    </div>
                    <div>
                      <UiInputPrice v-model="searchParamsLocal.preis" type="number" placeholder="€">
                        <template #label>
                          {{ t('maximum_price') }}
                        </template>
                        <template v-if="searchParamsLocal.preis" #value>
                          <span class="invisible">{{ searchParamsLocal.preis }}</span> &euro;
                        </template>
                      </UiInputPrice>
                    </div>
                  </div>
                </div>
              </template>
            </SearchFilterDropdown>
          </div>
          <div class="hidden lg:block min-w-0 overflow-hidden">
            <SearchFilterDropdown
              :results-count="resultsCount"
              :label-dropdown="t('room_and_equipment')"
              :active="searchParamsStore.activeFiltersCountForMultipleFields(['einzelzimmer', 'doppelbetten', 'einzelbetten'], []) > 0"
              @reset="searchParamsStore.$patch({einzelzimmer: 0, doppelbetten: 0, einzelbetten: 0}); resetSearchParamsLocal()"
              @shown="modalOrDropdownShown()"
              @hidden="modalOrDropdownHidden()"
            >
              <template #trigger>
                {{ t('room_and_equipment') }}
              </template>
              <template #default>
                <div class="grid pt-8 pb-8 px-5 gap-x-5 gap-y-5 min-w-[350px]">
                  <div class="grid grid-flow-col auto-cols-max place-content-between place-items-center gap-2 text-left">
                    <div>
                      {{ t('quantity_of_bedrooms') }}:
                    </div>
                    <UiQuantityChanger v-model="searchParamsLocal.einzelzimmer" :quantity-type="t('quantity_of_bedrooms')" />
                  </div>
                  <div class="grid grid-flow-col auto-cols-max place-content-between place-items-center gap-2 text-left">
                    <div>
                      {{ t('quantity_of_double_beds') }}
                    </div>
                    <UiQuantityChanger v-model="searchParamsLocal.doppelbetten" :quantity-type="t('quantity_of_double_beds')" />
                  </div>
                  <div class="grid grid-flow-col auto-cols-max place-content-between place-items-center gap-2 text-left">
                    <div>
                      {{ t('quantity_of_single_beds') }}
                    </div>
                    <UiQuantityChanger v-model="searchParamsLocal.einzelbetten" :quantity-type="t('quantity_of_single_beds')" />
                  </div>
                  <!--
                  <div class="grid grid-flow-col auto-cols-max place-content-between place-items-center gap-2 text-left">
                    <div>
                      {{ t('quantity_of_child_beds') }}
                    </div>
                    <UiQuantityChanger v-model="searchParamsLocal.kinderbetten" />
                  </div>
                  -->
                </div>
              </template>
            </SearchFilterDropdown>
          </div>
          <div v-if="!isCurrentPortalHundeLodge()" class="hidden lg:block min-w-0 overflow-hidden">
            <UiSearchFilterButton
              v-model="searchParamsStore.ausstattung_haustiere"
              :value="['kleintiere_erlaubt', 'katzen_erlaubt', 'hunde_alle_erlaubt', 'hunde_kleine_erlaubt']"
              :values-for-removal="['haustiere_nicht_erlaubt']"
            >
              {{ t('pets_allowed') }}
            </UiSearchFilterButton>
          </div>
        </div>
      </div>
    </div>
  </div>
  <UiModal
    ref="modal"
    :modal-id="modalId"
    :open="filter.showModal"
    width="md:w-220"
    :close-with-history-back="false"
    @shown="onFiltersModalShown"
    @hidden="onFiltersModalHidden"
  >
    <template #head>
      {{ t('filter') }}
    </template>
    <SearchFiltersModalSection
      v-if="countSelectedFilters > 0"
      position="first"
    >
      <template #title>
        {{ t('selected_filters') }}
      </template>
      <template #content>
        <!--
        <UiHeadline design="h3" type="div" class="mb-10">
          {{ t('popular') }}
        </UiHeadline>
        -->
        <div class="flex flex-wrap gap-4">
          <div v-for="(value, key) in selectedAusstattungFilters" :key="key">
            <UiSearchFilterButton v-model="searchParamsLocal.ausstattung" :value="Number(key)">
              {{ value }}
            </UiSearchFilterButton>
          </div>
          <div>
            <UiSearchFilterButton
              v-if="searchParamsLocal.bewertung_de !== '0'"
              v-model="searchParamsLocal.bewertung_de"
              :value="searchParamsLocal.bewertung_de"
              :true-value="searchParamsLocal.bewertung_de"
              :false-value="'0'"
            >
              <div class="flex items-center">
                <span class="font-semibold mr-1">
                  {{ searchParamsLocal.bewertung_de }}
                </span>
                <UiIcon
                  :src="`/svg/icons/star.svg`"
                  width="15"
                  height="15"
                />
              </div>
            </UiSearchFilterButton>
          </div>
          <div v-for="(value, key) in selectedNumericFilters" :key="key">
            <UiSearchFilterButton
              v-model="searchParamsLocal[key]"
              :value="Number(searchParamsLocal[key])"
              :true-value="Number(searchParamsLocal[key])"
              :false-value="0"
            >
              {{ searchParamsLocal[key] }} {{ t(value) }}
            </UiSearchFilterButton>
          </div>
          <div v-if="['kleintiere_erlaubt', 'katzen_erlaubt', 'hunde_alle_erlaubt', 'hunde_kleine_erlaubt'].every((x) => searchParamsLocal.ausstattung_haustiere?.includes(x))">
            <UiSearchFilterButton
              v-model="searchParamsLocal.ausstattung_haustiere"
              :value="['kleintiere_erlaubt', 'katzen_erlaubt', 'hunde_alle_erlaubt', 'hunde_kleine_erlaubt']"
              :values-for-removal="['haustiere_nicht_erlaubt']"
            >
              {{ t('pets_allowed') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="searchParamsLocal.ausstattung_haustiere?.includes('haustiere_nicht_erlaubt')">
            <UiSearchFilterButton
              v-model="searchParamsLocal.ausstattung_haustiere"
              :value="['haustiere_nicht_erlaubt']"
              :values-for-removal="['kleintiere_erlaubt', 'katzen_erlaubt', 'hunde_alle_erlaubt', 'hunde_kleine_erlaubt']"
            >
              {{ t('pets_not_allowed') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="searchParamsLocal.ausstattung_rauchen?.includes('ja')">
            <UiSearchFilterButton
              v-model="searchParamsLocal.ausstattung_rauchen"
              :value="['ja']"
              :values-for-removal="['nein']"
            >
              {{ t('smoking_allowed') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="searchParamsLocal.ausstattung_rauchen?.includes('nein')">
            <UiSearchFilterButton
              v-model="searchParamsLocal.ausstattung_rauchen"
              :value="['nein']"
              :values-for-removal="['ja']"
            >
              {{ t('smoking_not_allowed') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="searchParamsLocal.ausstattung_kueche?.includes('ja')">
            <UiSearchFilterButton
              v-model="searchParamsLocal.ausstattung_kueche"
              :value="['ja']"
              :values-for-removal="[]"
            >
              {{ t('kitchen_included') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="searchParamsLocal.haustyp?.includes('Ferienhaus')">
            <UiSearchFilterButton
              v-model="searchParamsLocal.haustyp"
              :value="['Ferienhaus']"
              :values-for-removal="[]"
            >
              {{ t('accommodation_type_house') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="searchParamsLocal.haustyp?.includes('Ferienwohnung')">
            <UiSearchFilterButton
              v-model="searchParamsLocal.haustyp"
              :value="['Ferienwohnung']"
              :values-for-removal="[]"
            >
              {{ t('accommodation_type_apartment') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="Number(searchParamsLocal.onlinebuchung) === 1">
            <UiSearchFilterButton
              v-model="searchParamsLocal.onlinebuchung"
              :value="1"
              :true-value="1"
              :false-value="0"
            >
              {{ t('onlinebooking') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="Number(searchParamsLocal.onlinebuchung) === -1">
            <UiSearchFilterButton
              v-model="searchParamsLocal.onlinebuchung"
              :value="-1"
              :true-value="-1"
              :false-value="0"
            >
              {{ t('non_binding_inquiry_booking') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="Number(searchParamsLocal.free_cancellation) === 1">
            <UiSearchFilterButton
              v-model="searchParamsLocal.free_cancellation"
              :value="1"
              :true-value="1"
              :false-value="0"
            >
              {{ t('free_cancellation') }}
            </UiSearchFilterButton>
          </div>
          <div v-if="typeof searchParamsLocal.urlaub === 'string' && searchParamsLocal.urlaub !== ''">
            <UiSearchFilterButton
              v-model="searchParamsLocal.urlaub"
              :value="searchParamsLocal.urlaub"
              :true-value="searchParamsLocal.urlaub"
              :false-value="''"
            >
              {{
                (
                  props.results?.params_decorated?.active_holiday_category?.title !== undefined
                  && props.results?.params_decorated?.active_holiday_category?.title !== null
                )
                  ? props.results?.params_decorated?.active_holiday_category?.title
                  : searchParamsLocal.urlaub
              }}
            </UiSearchFilterButton>
          </div>
          <div v-if="searchParamsLocal.distance_strand !== 0">
            <UiSearchFilterButton
              v-model="searchParamsLocal.distance_strand"
              :value="searchParamsLocal.distance_strand"
              :true-value="searchParamsLocal.distance_strand"
              :false-value="0"
            >
              {{ t('distance_beach_button', { distance: distanceStrandOptions[searchParamsLocal.distance_strand] }) }}
            </UiSearchFilterButton>
          </div>
        </div>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection
      v-bind="{
        ...(countSelectedFilters === 0 ? { position: 'first' } : {})
      }"
    >
      <template #title>
        {{ t('popular') }}
      </template>
      <template #content>
        <fieldset>
          <legend class="hidden">
            {{ t('popular') }}
          </legend>
          <div class="grid grid-cols-2 gap-4">
            <UiCheckbox
              v-if="!isCurrentPortalHundeLodge()"
              v-model="searchParamsLocal.ausstattung_haustiere"
              :value="['kleintiere_erlaubt', 'katzen_erlaubt', 'hunde_alle_erlaubt', 'hunde_kleine_erlaubt']"
              :deactivate-check="searchParamsLocal.ausstattung_haustiere?.includes('haustiere_nicht_erlaubt')"
              label-position="top"
              :accessibility-label="t('pets_allowed')"
            >
              <template #label>
                {{ t('pets_allowed') }}
              </template>
            </UiCheckbox>
            <UiCheckbox
              v-if="!isCurrentPortalHundeLodge()"
              v-model="searchParamsLocal.ausstattung_haustiere"
              :value="'haustiere_nicht_erlaubt'"
              :deactivate-check="['kleintiere_erlaubt', 'katzen_erlaubt', 'hunde_alle_erlaubt', 'hunde_kleine_erlaubt'].every((x) => searchParamsLocal.ausstattung_haustiere?.includes(x))"
              label-position="top"
              :accessibility-label="t('pets_not_allowed')"
            >
              <template #label>
                {{ t('pets_not_allowed') }}
              </template>
            </UiCheckbox>
            <UiCheckbox
              v-model="searchParamsLocal.ausstattung_rauchen"
              :value="'nein'"
              :disabled="searchParamsLocal.ausstattung_rauchen?.includes('ja')"
              label-position="top"
              :accessibility-label="t('smoking_not_allowed')"
            >
              <template #label>
                {{ t('smoking_not_allowed') }}
              </template>
            </UiCheckbox>
            <UiCheckbox
              v-model="searchParamsLocal.ausstattung"
              :value="16"
              label-position="top"
              :accessibility-label="`${findAmenityName(16)}`"
            >
              <template #label>
                {{ findAmenityName(16) }}
              </template>
            </UiCheckbox>
            <UiCheckbox
              v-model="searchParamsLocal.ausstattung"
              :value="7"
              label-position="top"
              :accessibility-label="`${findAmenityName(7)}`"
            >
              <template #label>
                {{ findAmenityName(7) }}
              </template>
            </UiCheckbox>
            <UiCheckbox
              v-model="searchParamsLocal.ausstattung"
              :value="62"
              label-position="top"
              :accessibility-label="`${findAmenityName(62)}`"
            >
              <template #label>
                {{ findAmenityName(62) }}
              </template>
            </UiCheckbox>
            <UiCheckbox
              v-model="searchParamsLocal.ausstattung"
              :value="2"
              label-position="top"
              :accessibility-label="`${findAmenityName(2)}`"
            >
              <template #label>
                {{ findAmenityName(2) }}
              </template>
            </UiCheckbox>
            <UiCheckbox
              v-model="searchParamsLocal.ausstattung"
              :value="28"
              label-position="top"
              :accessibility-label="`${findAmenityName(28)}`"
            >
              <template #label>
                {{ findAmenityName(28) }}
              </template>
            </UiCheckbox>
          </div>
          <div class="grid grid-cols-2 gap-4 mt-12">
            <div>
              <div class="mb-3 text-left">
                {{ t('quantity_of_bedrooms') }}
              </div>
              <UiQuantityChanger v-model="searchParamsLocal.einzelzimmer" :quantity-type="t('quantity_of_bedrooms')" />
            </div>
            <div>
              <div class="mb-3 text-left">
                {{ t('quantity_of_double_beds') }}
              </div>
              <UiQuantityChanger v-model="searchParamsLocal.doppelbetten" :quantity-type="t('quantity_of_double_beds')" />
            </div>
          </div>
        </fieldset>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection>
      <template #title>
        {{ t('per_night') }}
      </template>
      <template #content>
        <div class="grid grid-cols-2 gap-x-4 gap-y-2">
          <div>
            <UiInputPrice v-model="searchParamsLocal.preis_min" type="number" placeholder="€">
              <template #label>
                {{ t('minimum_price') }}
              </template>
              <template v-if="searchParamsLocal.preis_min" #value>
                <span class="invisible">{{ searchParamsLocal.preis_min }}</span> <span>&euro;</span>
              </template>
            </UiInputPrice>
          </div>
          <div>
            <UiInputPrice v-model="searchParamsLocal.preis" type="number" placeholder="€">
              <template #label>
                {{ t('maximum_price') }}
              </template>
              <template v-if="searchParamsLocal.preis" #value>
                <span class="invisible">{{ searchParamsLocal.preis }}</span> <span>&euro;</span>
              </template>
            </UiInputPrice>
          </div>
        </div>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection>
      <template #title>
        {{ t('distance_beach') }}
      </template>
      <template #content>
        <UiRadio
          v-for="(label, distance) in distanceStrandOptions"
          :key="distance"
          v-model="searchParamsLocal.distance_strand"
          :value="searchParamsLocal.distance_strand"
          :checked-value="Number(distance)"
          :unchecked-value="0"
          class="mr-2"
        >
          {{ label }}
        </UiRadio>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection v-if="!isCurrentPortalHundeLodge()">
      <template #title>
        {{ t('pets') }}
      </template>
      <template #content>
        <fieldset class="border-0 grid grid-cols-2 gap-4">
          <legend class="hidden">
            {{ t('pets') }}
          </legend>
          <UiCheckbox
            v-model="searchParamsLocal.ausstattung_haustiere"
            :value="['kleintiere_erlaubt', 'katzen_erlaubt', 'hunde_alle_erlaubt', 'hunde_kleine_erlaubt']"
            :deactivate-check="searchParamsLocal.ausstattung_haustiere?.includes('haustiere_nicht_erlaubt')"
            label-position="top"
            :accessibility-label="t('pets_allowed')"
          >
            <template #label>
              {{ t('pets_allowed') }}
            </template>
          </UiCheckbox>
          <UiCheckbox
            v-model="searchParamsLocal.ausstattung_haustiere"
            :value="'haustiere_nicht_erlaubt'"
            :deactivate-check="['kleintiere_erlaubt', 'katzen_erlaubt', 'hunde_alle_erlaubt', 'hunde_kleine_erlaubt'].every((x) => searchParamsLocal.ausstattung_haustiere?.includes(x))"
            label-position="top"
            :accessibility-label="t('pets_not_allowed')"
          >
            <template #label>
              {{ t('pets_not_allowed') }}
            </template>
          </UiCheckbox>
        </fieldset>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection>
      <template #title>
        {{ t('mindestbewertungen') }}
      </template>
      <template #content>
        <UiRadio
          v-for="rate in ['3.0', '3.5', '4.0', '4.5']"
          :key="rate"
          v-model="searchParamsLocal.bewertung_de"
          :value="searchParamsLocal.bewertung_de"
          :checked-value="rate"
          :unchecked-value="'0'"
          class="mr-2"
        >
          {{ rate }}
          <UiIcon
            :src="`/svg/icons/star.svg`"
            class="inline-block"
            style="margin-top: -3px"
            width="15"
            height="15"
          />
        </UiRadio>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection>
      <template #title>
        {{ t('bedroom_equipment') }}
      </template>
      <template #content>
        <div class="grid grid-cols-2 gap-3">
          <div>
            <div class="mb-3 text-left">
              {{ t('quantity_of_single_beds') }}
            </div>
            <UiQuantityChanger v-model="searchParamsLocal.einzelbetten" :quantity-type="t('quantity_of_single_beds')" />
          </div>
          <div>
            <div class="mb-3 text-left">
              {{ t('quantity_of_double_beds') }}
            </div>
            <UiQuantityChanger v-model="searchParamsLocal.doppelbetten" :quantity-type="t('quantity_of_double_beds')" />
          </div>
          <div>
            <div class="mb-3 text-left">
              {{ t('quantity_of_child_beds') }}
            </div>
            <UiQuantityChanger v-model="searchParamsLocal.kinderbetten" :quantity-type="t('quantity_of_child_beds')" />
          </div>
          <div>
            <div class="mb-3 text-left">
              {{ t('quantity_of_bedrooms') }}
            </div>
            <UiQuantityChanger v-model="searchParamsLocal.einzelzimmer" :quantity-type="t('quantity_of_bedrooms')" />
          </div>
        </div>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection>
      <template #title>
        {{ t('type_of_accommodation') }}
      </template>
      <template #content>
        <div class="grid grid-flow-col auto-cols-max gap-4">
          <UiSearchFilterBigButton v-model="searchParamsLocal.haustyp" :value="'Ferienhaus'">
            <template #icon>
              <UiIcon src="/svg/icons/ferienhaus.svg" width="36" height="36" class="fill-neutral-800 inline-block" />
            </template>
            {{ t('accommodation_type_house') }}
          </UiSearchFilterBigButton>
          <UiSearchFilterBigButton v-model="searchParamsLocal.haustyp" :value="'Ferienwohnung'">
            <template #icon>
              <UiIcon src="/svg/icons/ferienwohnung.svg" width="36" height="36" class="fill-neutral-800 inline-block" />
            </template>
            {{ t('accommodation_type_apartment') }}
          </UiSearchFilterBigButton>
        </div>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection>
      <template #title>
        {{ t('booking_conditions') }}
      </template>
      <template #content>
        <fieldset class="border-0 grid grid-cols-2 gap-3">
          <legend class="hidden">
            {{ t('booking_conditions') }}
          </legend>
          <div>
            <UiCheckbox
              v-model="searchParamsLocal.onlinebuchung"
              :true-value="1"
              :false-value="0"
              :deactivate-check="searchParamsLocal.onlinebuchung === -1"
              label-position="top"
              :accessibility-label="t('onlinebooking')"
            >
              <template #label>
                {{ t('onlinebooking') }}
              </template>
            </UiCheckbox>
          </div>
          <div>
            <UiCheckbox
              v-model="searchParamsLocal.onlinebuchung"
              :true-value="-1"
              :false-value="0"
              :deactivate-check="searchParamsLocal.onlinebuchung === 1"
              label-position="top"
              :accessibility-label="t('non_binding_inquiry_booking')"
            >
              <template #label>
                {{ t('non_binding_inquiry_booking') }}
              </template>
            </UiCheckbox>
          </div>
        </fieldset>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection>
      <template #title>
        {{ t('cancellation') }}
      </template>
      <template #content>
        <div class="grid grid-cols-1 gap-3">
          <div>
            <UiSwitch v-model="searchParamsLocal.free_cancellation" :true-value="1" :false-value="0">
              <template #label>
                {{ t('free_cancellation') }}
              </template>
            </UiSwitch>
          </div>
        </div>
      </template>
    </SearchFiltersModalSection>
    <SearchFiltersModalSection>
      <template #title>
        {{ t('equipments') }}
      </template>
      <template #content>
        <template v-for="amenity in amenitiesData.data" :key="amenity">
          <fieldset v-if="amenity.id != 8 && amenity.id != 9" class="border-0 flex flex-col w-full">
            <legend class="font-semibold">
              {{ amenity.name }}:
            </legend>
            <div class="grid grid-cols-2 gap-3 mt-5 mb-6">
              <template v-for="merkmale in amenity.merkmale" :key="merkmale">
                <UiCheckbox
                  v-if="merkmale.suchform === '1'"
                  v-model="searchParamsLocal.ausstattung"
                  :value="merkmale.id"
                  label-position="top"
                  :accessibility-label="merkmale.name"
                >
                  <template #label>
                    {{ merkmale.name }}
                  </template>
                </UiCheckbox>
              </template>
              <template v-if="amenity.id == 10">
                <template v-for="(sonstige, id) in additionalSonstigeAmenities" :key="id">
                  <UiCheckbox
                    v-model="searchParamsLocal.ausstattung"
                    :value="Number(id)"
                    label-position="top"
                    :accessibility-label="sonstige"
                  >
                    <template #label>
                      {{ sonstige }}
                    </template>
                  </UiCheckbox>
                </template>
                <UiCheckbox
                  v-model="searchParamsLocal.ausstattung_rauchen"
                  :value="'nein'"
                  :disabled="searchParamsLocal.ausstattung_rauchen?.includes('ja')"
                  label-position="top"
                  :accessibility-label="t('smoking_not_allowed')"
                >
                  <template #label>
                    {{ t('smoking_not_allowed') }}
                  </template>
                </UiCheckbox>
                <UiCheckbox
                  v-model="searchParamsLocal.ausstattung_rauchen"
                  :value="'ja'"
                  :disabled="['nein'].every((x) => searchParamsLocal.ausstattung_rauchen?.includes(x))"
                  label-position="top"
                  :accessibility-label="t('smoking_allowed')"
                >
                  <template #label>
                    {{ t('smoking_allowed') }}
                  </template>
                </UiCheckbox>
              </template>
            </div>
          </fieldset>
        </template>
        <DevTestOnly>
          <UiInput
            design="normal"
            label-position="top"
            bg-colour="bg-neutral-50"
            :placeholder="t('placeholder_free_text_search')"
            class="mt-5"
          >
            <template #label>
              {{ t('free_text_search') }}
            </template>
          </UiInput>
        </DevTestOnly>
      </template>
    </SearchFiltersModalSection>
    <DevTestOnly>
      <SearchFiltersModalSection>
        <template #title>
          {{ t('show_accommodation_directly') }}
        </template>
        <template #content>
          <div class="flex flex-row justify-end content-end">
            <UiInput
              design="normal"
              label-position="top"
              bg-colour="bg-neutral-50"
              :placeholder="t('search_for_accommodation_placeholder')"
              inputstyle="w-full rounded-l-xl"
            >
              <template #label>
                {{ t('search_for_accommodation') }}
              </template>
            </UiInput>
            <div class="flex flex-col content-end justify-end">
              <UiButton class="flex-none h-[55px] text-nowrap rounded-l-none rounded-r-xl" :disabled="true">
                {{ t('button_view_accommodation') }}
              </UiButton>
            </div>
          </div>
        </template>
      </SearchFiltersModalSection>
    </DevTestOnly>
    <template #foot>
      <div class="border-t-2 border-neutral-100 grid grid-cols-2 gap-2 content-center py-4 px-4 text-left">
        <div class="flex items-center">
          <span
            role="button"
            tabindex="0"
            class="cursor-pointer"
            @click="searchParamsStore.resetToDefaultStateExceptOrtVonBisPersonen(false, props.showOnlyLastminuteObjects); resetSearchParamsLocal()"
            @keydown.enter="searchParamsStore.resetToDefaultStateExceptOrtVonBisPersonen(false, props.showOnlyLastminuteObjects); resetSearchParamsLocal()"
          >
            {{ t('reset_filters') }}
          </span>
        </div>
        <div class="place-self-end">
          <UiButton @click="modal?.hide">
            <!--NaN Ergebnisse-->
            {{ t('show_results') }}
            ({{ resultsCount }})
          </UiButton>
        </div>
      </div>
    </template>
  </UiModal>
</template>

<script setup lang="ts">
import type { ComputedRef } from 'vue'
import UiSearchFilterBigButton from '../../ui/UiSearchFilterBigButton.vue'
import type SearchParams from '~/types/search/SearchParams'
import SearchParamsHelper from '~/utils/search/SearchParamsHelper'
import SearchFiltersModalSection from '~/components/page-sections/search/SearchFiltersModalSection'
import { useSearchParamsStore } from '~~/stores/searchParams'
import { useSearchResultsMapStore } from '~~/stores/searchResultsMap'
import { BREAKPOINT_LG_PX } from '~/utils/breakpoints'

const t = useTranslations('SearchFilters').translate
const modalId = useComponentId('search-filters')

const props = defineProps({
  results: {
    type: Object,
    default: null
  },
  showOnlyLastminuteObjects: {
    type: Boolean,
    default: false
  },
  flexSearch: {
    type: Boolean,
    default: true
  }
})

let isModalOrDropdownOpen = false
const searchParamsStore = useSearchParamsStore()
const { currentPortal, isCurrentPortalHundeLodge } = usePortals()

const config = currentPortal.value.search_form
if (config.appearance === 'input') {
  searchParamsStore.ort = props.results?.location?.ort?.region ?? props.results?.location?.ort
}
const searchParamsLocal = ref(searchParamsStore.stateDeepClone())
onMounted(() => {
  nextTick(() => {
    resetSearchParamsLocal()
  })
})
const filtersModalInitialParams = ref<SearchParams | null>(null)
const guestsFilterInitialParams = ref<SearchParams | null>(null)
const resultsCount = ref(props.results?.hits ?? 0)
watch(
  () => props.results,
  (newValue) => {
    resultsCount.value = newValue?.hits ?? 0
  }
)
const update = (event) => {
  const updatedParams = {}
  Object.entries(event).forEach(([key, value]) => {
    updatedParams[key] = value
  })
  searchParamsStore.$patch(updatedParams)
}
const resetSearchParamsLocal = () => {
  searchParamsLocal.value = searchParamsStore.stateDeepClone()
}
const updateLocal = (event) => {
  Object.entries(event).forEach(([key, value]) => {
    searchParamsLocal.value[key] = value
  })
}
const modalOrDropdownShown = () => {
  isModalOrDropdownOpen = true
  resetSearchParamsLocal()
}
const onFiltersModalShown = () => {
  modalOrDropdownShown()
  filtersModalInitialParams.value = searchParamsStore.stateDeepClone()
}
const onGuestsModalOrDropdownShown = () => {
  modalOrDropdownShown()
  guestsFilterInitialParams.value = searchParamsStore.stateDeepClone()
}
const modalOrDropdownHidden = () => {
  if (!isModalOrDropdownOpen) {
    return
  }
  isModalOrDropdownOpen = false

  // Always apply filters when modal/dropdown closes
  if (searchParamsLocal.value.von !== '' && searchParamsLocal.value.bis === '') {
    searchParamsLocal.value.von = searchParamsStore.von
    searchParamsLocal.value.bis = searchParamsStore.bis
    return
  }
  searchParamsStore.$patch(searchParamsLocal.value)
}
const onGuestsModalOrDropdownHidden = (reason?: string) => {
  if (reason === 'popstate') {
    isModalOrDropdownOpen = false
    resetSearchParamsLocal()
    return
  }

  const initial = guestsFilterInitialParams.value
  guestsFilterInitialParams.value = null

  if (!initial) {
    modalOrDropdownHidden()
    return
  }

  const hasChanges = !SearchParamsHelper.areSearchParamsObjectsIdentical(initial, searchParamsLocal.value)

  if (!hasChanges) {
    resetSearchParamsLocal()
    if (import.meta.client && window.history.state?.modalOpen === true && window.history.state?.modalId) {
      window.history.back()
    }
    return
  }

  modalOrDropdownHidden()
}
const onFiltersModalHidden = (reason?: string) => {
  filter.showModal = false

  // Back button should only close the modal (cancel), not apply pending filter changes.
  if (reason === 'popstate') {
    isModalOrDropdownOpen = false
    resetSearchParamsLocal()
    return
  }

  const initial = filtersModalInitialParams.value
  filtersModalInitialParams.value = null

  if (!initial) {
    modalOrDropdownHidden()
    return
  }

  const hasChanges = !SearchParamsHelper.areSearchParamsObjectsIdentical(initial, searchParamsLocal.value)

  if (!hasChanges) {
    resetSearchParamsLocal()
    if (import.meta.client && window.history.state?.modalOpen === true && window.history.state?.modalId === modalId) {
      window.history.back()
    }
    return
  }

  modalOrDropdownHidden()
}
async function getResultsCount (params) {
  const { $backend } = useNuxtApp()
  const searchResultsResponse = await $backend.search.searchFromClient(params)
  resultsCount.value = searchResultsResponse?.data?.hits || 0
}
watch(
  searchParamsLocal,
  (newValue) => {
    if (isModalOrDropdownOpen) {
      getResultsCount(newValue)
    }
  },
  { deep: true }
)
watch(
  searchParamsStore,
  (newValue) => {
    if (isModalOrDropdownOpen && !SearchParamsHelper.areSearchParamsObjectsIdentical(newValue.$state, searchParamsLocal.value)) {
      resetSearchParamsLocal()
    }
  },
  { deep: true })

const mapStore = useSearchResultsMapStore()
const mapFullsize = () => {
  if (window.innerWidth < BREAKPOINT_LG_PX && !mapStore.fullSize) {
    mapStore.visible = true
    setTimeout(() => {
      mapStore.fullSize = true
    }, 300)
  } else if (window.innerWidth < BREAKPOINT_LG_PX && mapStore.fullSize) {
    mapStore.fullSize = false
    mapStore.visible = false
  }
}
const mapButtonClick = () => {
  if (mapStore.isAppleDevice) {
    // iOS: Use fullscreen mode
    mapFullsize()
  } else {
    // Android + Desktop narrow viewport: Open modal
    mapStore.mapModalOpen = true
  }
}
const { $backend } = useNuxtApp()
const { data: amenitiesData } = await $backend.amenities.getAllAmenities()

const merkmaleMap: Record<number, string> = {}
for (const amenity of amenitiesData.value.data) {
  for (const merkmale of amenity.merkmale) {
    merkmaleMap[merkmale.id] = merkmale.name
  }
}
const additionalSonstigeAmenities = {
  16: merkmaleMap[16],
  2: merkmaleMap[2],
  37: merkmaleMap[37],
  33: merkmaleMap[33],
  30: merkmaleMap[30]
}
const selectedAusstattungFilters: ComputedRef<Record<number, string>> = computed(() => {
  const result: Record<number, string> = {}
  for (const key of searchParamsLocal.value.ausstattung) {
    if (!Object.prototype.hasOwnProperty.call(merkmaleMap, key)) {
      continue
    }
    result[key] = merkmaleMap[key]
  }
  return result
})
function findAmenityName (id) {
  for (const item of amenitiesData.value.data) {
    const merkmal = item.merkmale.find(merkmal => merkmal.id === id)
    if (merkmal) {
      return merkmal.name
    }
  }
}
const numericFiltersLanguagePlaceholders: Record<string, string> = {
  kinderbetten: 'selected_filters_quantity_of_child_beds',
  einzelbetten: 'selected_filters_quantity_of_single_beds',
  doppelbetten: 'selected_filters_quantity_of_double_beds',
  einzelzimmer: 'selected_filters_quantity_of_bedrooms',
  preis: 'selected_filters_maximum_price',
  preis_min: 'selected_filters_minimum_price'
}
const selectedNumericFilters: ComputedRef<Record<string, string>> = computed(() => {
  const result: Record<string, string> = {}
  for (const key in numericFiltersLanguagePlaceholders) {
    if (Object.prototype.hasOwnProperty.call(searchParamsLocal.value, key) && searchParamsLocal.value[key] !== 0) {
      result[key] = numericFiltersLanguagePlaceholders[key]
    }
  }
  return result
})
const countSelectedFilters: ComputedRef<number> = computed(() => {
  let count = 0
  count += Object.keys(selectedAusstattungFilters.value)?.length ?? 0
  count += searchParamsLocal.value.ausstattung_haustiere?.length ? 1 : 0
  count += searchParamsLocal.value.ausstattung_rauchen?.length ? 1 : 0
  count += searchParamsLocal.value.ausstattung_kueche?.length ? 1 : 0
  count += searchParamsLocal.value.bewertung_de !== '0' ? 1 : 0
  count += searchParamsLocal.value.haustyp?.includes('Ferienhaus') ? 1 : 0
  count += searchParamsLocal.value.haustyp?.includes('Ferienwohnung') ? 1 : 0
  count += [-1, 1].includes(Number(searchParamsLocal.value.onlinebuchung)) ? 1 : 0
  count += Number(searchParamsLocal.value.free_cancellation) === 1 ? 1 : 0
  count += Number(searchParamsLocal.value.kinderbetten) !== 0 ? 1 : 0
  count += Number(searchParamsLocal.value.einzelbetten) !== 0 ? 1 : 0
  count += Number(searchParamsLocal.value.doppelbetten) !== 0 ? 1 : 0
  count += Number(searchParamsLocal.value.einzelzimmer) !== 0 ? 1 : 0
  count += Number(searchParamsLocal.value.preis) !== 0 ? 1 : 0
  count += Number(searchParamsLocal.value.preis_min) !== 0 ? 1 : 0
  count += typeof searchParamsLocal.value.urlaub === 'string' && (searchParamsLocal.value.urlaub) !== '' ? 1 : 0
  return count
})

const filter = reactive({
  showModal: false
})

const modal = ref()
if (import.meta.client) {
  const userAgent = window.navigator.userAgent
  mapStore.isAppleDevice = /iPad|iPhone/i.test(userAgent)
}

const distanceStrandOptions = computed((): Record<number, string> => ({
  200: t.value('distance_beach_200'),
  500: t.value('distance_beach_500'),
  1000: t.value('distance_beach_1000'),
  5000: t.value('distance_beach_5000'),
  0: t.value('distance_beach_any'),
}))

</script>
<style>
.custom-dropdown-trigger-block{
  &> div {
    @apply w-full;
    display: block !important;
    margin: 0 !important;
    border: 0 !important;
  }
}
</style>
